import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_FEATURES_QUERY_KEY } from '@/state/queries/features/use-get-features';
import { GET_FEATURE_QUERY_KEY } from '@/state/queries/features/use-get-feature';
import type { Feature, UpdateFeatureDto } from '@/types/features';

export const useUpdateFeatureMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: UpdateFeatureDto }) => {
      const token = await getToken();
      return updateFeature(id, data, token ?? '');
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [GET_FEATURES_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [GET_FEATURE_QUERY_KEY, data.id] });
      // Invalidate all feature access checks to refresh frontend with updated feature flag data
      queryClient.invalidateQueries({ queryKey: ['check-feature-access'] });
    },
  });
};

const updateFeature = async (id: string, data: UpdateFeatureDto, token: string): Promise<Feature> => {
  const url = `${import.meta.env.VITE_API_URL}/features/${id}`;
  return sendJSONRequest({ url, method: METHOD.PATCH, body: data, token }) as Promise<Feature>;
};
